import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./CleanLayout.css";

interface CleanLayoutProps {
  children: React.ReactNode;
  title?: string;
  backgroundColor?: string;
  className?: string;
}

const CleanLayout: React.FC<CleanLayoutProps> = ({
  children,
  title = "Foo | Pídelo en Línea",
  backgroundColor = "#ffbb28",
  className = "",
}) => {
  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="theme-color" content={backgroundColor} />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1, user-scalable=no"
        />
      </Helmet>

      <main
        className={`clean-layout ${className}`}
        style={{ backgroundColor }}
      >
        {children}
      </main>

      <footer className="footer clean-footer">
        <div className="container text-center py-3">
          <p className="text-muted mb-0">
            © {new Date().getFullYear()} Foo. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </>
  );
};

export default CleanLayout;
